import React, { useState, useEffect, useRef } from "react";
import "./ScenarioToolbar.css";
import api from "../../api/axios";
import SaveStatus from "../Common/SaveStatus";
import { useDebouncedAutosave } from "../../hooks/useDebouncedAutosave";

const ScenarioToolbar = ({ selectedScenario, onScenarioUpdated }) => {
  const hasScenario = !!selectedScenario;

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [nameError, setNameError] = useState(false);

  const scenarioRef = useRef(selectedScenario);
  scenarioRef.current = selectedScenario;
  const onUpdatedRef = useRef(onScenarioUpdated);
  onUpdatedRef.current = onScenarioUpdated;

  // Only name/description, via PATCH /scenario/{id}/info - never overwrites
  // settings or sections that are saved elsewhere.
  const { status, schedule, flush } = useDebouncedAutosave(async (info) => {
    const current = scenarioRef.current;
    if (!current?.id) return;

    const body = { description: info.description };
    if (info.name.trim()) body.name = info.name.trim(); // empty name is never saved

    await api.patch(`/scenario/${current.id}/info`, body);
    onUpdatedRef.current?.({ ...current, ...body });
  }, 800);

  // Sync local fields only when a different scenario is opened
  useEffect(() => {
    if (!selectedScenario) return;
    setName(selectedScenario.name || "");
    setDescription(selectedScenario.description || "");
    setNameError(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedScenario?.id]);

  const handleNameChange = (value) => {
    setName(value);
    setNameError(!value.trim());
    schedule({ name: value, description });
  };

  const handleDescriptionChange = (value) => {
    setDescription(value);
    schedule({ name, description: value });
  };

  return (
    <div className="scenario-toolbar-container">
      {hasScenario && (
        <div className="scenario-name-block">
          <div className="scenario-toolbar-status">
            <SaveStatus status={status} />
          </div>

          {/* NAME */}
          <label className="scenario-edit-label">Scenario name:</label>
          <input
            className={`scenario-edit-input${nameError ? " scenario-edit-input--error" : ""}`}
            value={name}
            onChange={(e) => handleNameChange(e.target.value)}
            onBlur={flush}
          />
          {nameError && (
            <span className="scenario-edit-error">The name must not be empty.</span>
          )}

          {/* DESCRIPTION */}
          <label className="scenario-edit-label">Description:</label>
          <textarea
            className="scenario-edit-textarea"
            value={description}
            onChange={(e) => handleDescriptionChange(e.target.value)}
            onBlur={flush}
          />
        </div>
      )}
    </div>
  );
};

export default ScenarioToolbar;
